export default "__VITE_ASSET__CTCVK4z8__"